import React from 'react';
import PropTypes from 'prop-types';
import ImageContainer from './';
import { imageBorderRadius } from 'themes';

const BannerContainer = ({ children, containerAttr, imageAttr }) => (
  <ImageContainer
    containerAttr={{
      ...containerAttr,
      styles: `
        position: relative;
      `
    }}
    imageAttr={{
      ...imageAttr,
      styles: `
        border-radius: ${imageBorderRadius};
      `
    }}
  >
    {children}
  </ImageContainer>
);

BannerContainer.propTypes = {
  containerAttr: PropTypes.shape({
    styles: PropTypes.shape()
  }),
  imageAttr: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    styles: PropTypes.shape()
  })
};

export default BannerContainer;
